var map = {
	"./abb-color.svg": 1766,
	"./afb-color.svg": 1767,
	"./afb.svg": 1768,
	"./agro-color.svg": 1769,
	"./alb-color.svg": 1770,
	"./alb.svg": 1771,
	"./amb-color.svg": 1772,
	"./amb.svg": 1773,
	"./bbbaidja-color.svg": 1774,
	"./bbbaidjaxxx-color.svg": 1775,
	"./bdinidjaxxx-color.svg": 1776,
	"./bimb-color.svg": 1777,
	"./bimb.svg": 1778,
	"./bkr-color.svg": 1779,
	"./bkr.svg": 1780,
	"./bmriidja-color.svg": 1781,
	"./bniaidja-color.svg": 1782,
	"./bninidja-color.svg": 1783,
	"./bninidjaxxx-color.svg": 1784,
	"./boc-color.svg": 1785,
	"./bpay-color.svg": 1786,
	"./brinidja002-color.svg": 1787,
	"./bsmdidjaxxx-color.svg": 1788,
	"./bsn-color.svg": 1789,
	"./bsn.svg": 1790,
	"./btanidjaxxx-color.svg": 1791,
	"./cenaidja-color.svg": 1792,
	"./cenaidjaxxx-color.svg": 1793,
	"./cimb-color.svg": 1794,
	"./cimb.svg": 1795,
	"./citi-color.svg": 1796,
	"./citi.svg": 1797,
	"./default-bank-icon-color.png": 1798,
	"./default-bank-icon.png": 1799,
	"./gxbank-color.svg": 1800,
	"./hlb-color.svg": 1801,
	"./hlb.svg": 1802,
	"./hsbc-color.svg": 1803,
	"./hsbc.svg": 1804,
	"./ibbkidjaxxx-color.svg": 1805,
	"./kfh-color.svg": 1806,
	"./kwh-color.svg": 1807,
	"./kwh.svg": 1808,
	"./mbb-color.svg": 1809,
	"./mbb.svg": 1810,
	"./muamalat-color.svg": 1811,
	"./nispidjaxxx-color.svg": 1812,
	"./ocbc-color.svg": 1813,
	"./ocbc.svg": 1814,
	"./pbb-color.svg": 1815,
	"./pbb.svg": 1816,
	"./pinbidja-color.svg": 1817,
	"./raykat-color.svg": 1818,
	"./rhb-b.svg": 1819,
	"./rhb-color-b.svg": 1820,
	"./rhb-color.svg": 1821,
	"./rhb.svg": 1822,
	"./scb-color.svg": 1823,
	"./scb.svg": 1824,
	"./tng-color.svg": 1825,
	"./uob-color.svg": 1826,
	"./uob.svg": 1827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;